// extracted by mini-css-extract-plugin
export default {"component-container":"PredefinedModuleSection_component-container__ApPiM","coming-soon":"PredefinedModuleSection_coming-soon__7DSLN"};